// 의존성 없는 순수 모듈로 둔다. helpers.js 는 fflate 와 configs 를 끌어오고 확장자 없는
// import 를 써서 번들러 없이는 못 읽는데, 이 블렌드는 화면에 그대로 보이는 값이라
// 단독으로 검사할 수 있어야 한다.
// 검사: node tools/test-blend-color.mjs

/**
 * Mixes two colours as if a film of `overlay` at `alpha` opacity were laid over
 * `base`. This is source-over compositing with an opaque backdrop, which is what a
 * translucent overlay resolves to once it is flattened.
 *
 * The colour texture stores alpha as a hardcoded 255, so a real translucent pass
 * would need shader work. Blending on the CPU produces the same picture for a film
 * that covers the whole object, which is the case here.
 *
 * @param {Array<number>} base - Backdrop RGB, each 0-255
 * @param {Array<number>} overlay - Film RGB, each 0-255
 * @param {number} alpha - Film opacity, 0 (invisible) to 1 (opaque)
 * @returns {Array<number>} Resulting RGB, each 0-255 and rounded
 */
export function blendRGB(base, overlay, alpha) {
    return base.map((channel, i) => Math.round(channel + (overlay[i] - channel) * alpha));
}
